import { useState } from 'react'
import { MaterialIcon } from '@/ui/material-icon'
import styles from './PipelineDetailsSheet.module.scss'

export type PipelineDetailsSheetProps = {
  onClose: () => void
  pipelineName: string
  /** Display label for pipeline status (e.g. Not Started) */
  runStatusLabel?: string
  onViewRunHistory?: () => void
}

const MOCK_LOGS: { kind: 'success' | 'error' | 'warning'; message: string; time: string }[] = [
  {
    kind: 'success',
    message:
      'Lorem ipsum dolor sit amet, sdgskop consectetur adipiscing elit,',
    time: '02/20/2026, 3:29 PM',
  },
  {
    kind: 'error',
    message:
      'Lorem ipsum dolor sit amet, sdgskop consectetur adipiscing elit,',
    time: '02/20/2026, 3:29 PM',
  },
  {
    kind: 'warning',
    message:
      'Lorem ipsum dolor sit amet, sdgskop consectetur adipiscing elit,',
    time: '02/20/2026, 3:29 PM',
  },
]

export function PipelineDetailsSheet({
  onClose,
  pipelineName,
  runStatusLabel = 'Not Started',
  onViewRunHistory,
}: PipelineDetailsSheetProps) {
  const [runDetailsOpen, setRunDetailsOpen] = useState(true)

  return (
    <aside
      className={styles.root}
      aria-label={`${pipelineName} pipeline run details`}
    >
      <div className={styles.inner}>
        <div className={styles.headerRow}>
          <div className={styles.headerLeft}>
            <button
              type="button"
              className={styles.closeChevron}
              onClick={onClose}
              aria-label="Close pipeline details"
            >
              <span aria-hidden>&gt;&gt;</span>
            </button>
            <div className={styles.titleCluster}>
              <span className={styles.pipelineNameBold}>{pipelineName}</span>
              <span className={styles.pipelineSuffix}>Pipeline</span>
            </div>
          </div>
          <div className={styles.headerActions}>
            <button
              type="button"
              className={styles.iconCircleBtn}
              aria-label="Refresh pipeline status"
              onClick={() => {}}
            >
              <MaterialIcon name="refresh" size={20} />
            </button>
            <button
              type="button"
              className={styles.viewHistoryBtn}
              onClick={() => onViewRunHistory?.()}
            >
              <MaterialIcon name="history" size={18} />
              View Run History
            </button>
          </div>
        </div>

        <div className={styles.statusCard}>
          <div className={styles.statusRow}>
            <span className={styles.statusLabel}>Status</span>
            <div className={styles.statusPillInline}>
              <span className={styles.statusDot} aria-hidden />
              {runStatusLabel}
            </div>
          </div>
          <div className={styles.statusRow}>
            <span className={styles.statusLabel}>Duration</span>
            <span className={styles.statusValue}>00:00:00</span>
          </div>
          <div className={styles.statusRow}>
            <span className={styles.statusLabel}>Run Start</span>
            <span className={styles.statusValue}>19/02/2026 00:00:00</span>
          </div>
          <div className={styles.statusRow}>
            <span className={styles.statusLabel}>Run End</span>
            <span className={styles.statusValue}>19/02/2026 00:00:00</span>
          </div>
        </div>

        <div className={styles.runDetails}>
          <button
            type="button"
            className={styles.runDetailsToggle}
            onClick={() => setRunDetailsOpen(v => !v)}
            aria-expanded={runDetailsOpen}
          >
            Run Details
            <MaterialIcon
              name={runDetailsOpen ? 'expand_less' : 'expand_more'}
              size={22}
            />
          </button>
          {runDetailsOpen && (
            <div className={styles.runDetailsBody}>
              <div className={styles.fieldRow}>
                <span className={styles.fieldLabel}>Created By</span>
                <span className={styles.fieldValue}>Lorem ipsum</span>
              </div>
              <div className={styles.fieldRow}>
                <span className={styles.fieldLabel}>Last Edited By</span>
                <span className={styles.fieldValue}>Lorem ipsum</span>
              </div>
            </div>
          )}
        </div>

        <div className={styles.eventsSection}>
          <h3 className={styles.eventsHeading}>Events and real time progress</h3>
          <ul className={styles.eventsList}>
            {MOCK_LOGS.map((log, i) => (
              <li key={i} className={styles.eventItem}>
                <span
                  className={`${styles.eventIcon} ${styles[log.kind]}`}
                  aria-hidden
                >
                  {log.kind === 'success' && (
                    <MaterialIcon name="check" size={14} />
                  )}
                  {log.kind === 'error' && <MaterialIcon name="close" size={14} />}
                  {log.kind === 'warning' && (
                    <MaterialIcon name="chat_bubble" size={14} />
                  )}
                </span>
                <div className={styles.eventMain}>
                  <p className={styles.eventMessage}>{log.message}</p>
                  <span className={styles.eventTime}>{log.time}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  )
}
